import * as React from 'react';
import { Box, Paper, Typography, Alert, Stack, Chip } from '@mui/material';

function getConnectionStatus(gateway) {
  return String(gateway?.iot_connection?.status || 'unknown').toLowerCase();
}

function getStatusColor(status) {
  const normalized = String(status || '').toLowerCase();

  if (normalized === 'connected') return 'success';
  if (normalized === 'disconnected') return 'warning';
  if (normalized === 'error') return 'error';
  return 'default';
}

export default function GreengrassGatewayMap({ data }) {
  const gateways = Array.isArray(data?.gateways) ? data.gateways : [];

  if (gateways.length === 0) {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2,
          border: '1px solid',
          borderColor: 'divider',
          borderRadius: 2,
        }}
      >
        <Alert severity="warning">
          No gateway data is available for this account context.
        </Alert>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Gateway Overview
      </Typography>

      <Stack spacing={2}>
        {gateways.map((gateway, index) => (
          <Box
            key={gateway.gateway_id || index}
            sx={{
              p: 2,
              border: '1px solid',
              borderColor: 'divider',
              borderRadius: 2,
            }}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {gateway.display_name || gateway.gateway_code || `Gateway ${index + 1}`}
            </Typography>

            <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
              <Chip
                size="small"
                color={getStatusColor(getConnectionStatus(gateway))}
                label={`IoT Status: ${getConnectionStatus(gateway)}`}
              />

              {gateway.gateway_code && (
                <Chip size="small" label={`Code: ${gateway.gateway_code}`} />
              )}

              {gateway.gateway_id && (
                <Chip size="small" label={`ID: ${gateway.gateway_id}`} />
              )}

              {gateway.iot_connection?.timestamp && (
                <Chip
                  size="small"
                  label={`Last Seen: ${new Date(gateway.iot_connection.timestamp).toLocaleString()}`}
                />
              )}
            </Stack>

            {gateway.iot_connection?.disconnect_reason ? (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                Disconnect reason: {gateway.iot_connection.disconnect_reason}
              </Typography>
            ) : null}
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}
